import React from "react";
import { ProductReviewDetail } from "../../reviewModels";
import ReviewMultipleVariantDetails from "../ReviewMultipleVariantDetails";

type VGDetail = {
  name: string;
  value: string;
  sortIndex: number;
};

interface ReviewVGVariantDetailsProps {
  review: ProductReviewDetail;
  styles?: string;
}

const ReviewVGVariantDetails = ({
  review,
  styles,
}: ReviewVGVariantDetailsProps) => {
  const hasVariations = (review.variations?.length ?? 0) > 1;

  const VGSorted =
    review.virtualGroupDetails?.sort((a, b) => a.sortIndex - b.sortIndex) || [];

  return (
    <div className={styles}>
      <ReviewMultipleVariantDetails review={review} />

      {review.virtualGroupDetails &&
        VGSorted.map((detail: VGDetail) => (
          <dl
            className={`flex m-0 ${hasVariations ? "mt-0.5" : ""}`}
            key={detail.name}
          >
            <dt className="font-bold">{detail.name}:</dt>
            <dd className="ml-1">{detail.value}</dd>
          </dl>
        ))}
    </div>
  );
};

export default ReviewVGVariantDetails;
